<script>
import baseEdit from "@/views/components/base/baseEdit.vue";
const customerId = window.localStorage.getItem("customerId")
export default {
    extends: baseEdit,
    components: {},
    data() {
        return {
            mname: "patrol",
            key: "id",
            url: {
                get: "/admin/system/facilityRate",
                add: "/admin/system/facilityRate/add",
                edit: "/admin/system/facilityRate/edit",
            },
            items: [
                { label: "基本信息", desc: "表单的基本信息", type: "header" },
                {
                    label: "资产类型",
                    name: "facilityTypeId",
                    value: "",
                    type: "select",
                    width: "240px",
                    dropList: [
                    ],
                    rules: [{ required: true, trigger: "blur", type: "number" }],
                },
                {
                    label: "月服务费（元）",
                    name: "monthPayNumber",
                    value: "",
                    type: "number",
                    min: 0,
                    precision: 0,
                    width: "240px",
                    rules: [{ required: true, trigger: "blur", type: "number" }],
                },
              {
                label: "供应商",
                name: "supplierId",
                value: "",
                type: "select",
                width: "240px",
                dropList: [
                ],
                rules: [{ required: true, trigger: "blur", type: "number" }],
              },
              {
                label: "折扣率（%）",
                name: "rateMouth",
                value: 100,
                type: "number",
                min: 1,
                max:100,
                width: "240px",
                rules: [{ required: true, trigger: "blur", type: "number" }],
              },
            ],
            forms: {},
        };
    },
    created() {
        let query = this.$route.query;
        this.getFacilityType(query.facilityTypeId)
        this.getSupplierList()
    },
    mounted() {
    },
    methods: {
      async getSupplierList() {
        let d = {
          customerId: Number(customerId) === 0 ? window.localStorage.getItem("customerIdClick") : Number(customerId)
        }
        let res = await $utils.api.load('/admin/system/supplier/selectList', d, "get")
        if (res.code == 200) {
          let ll = res.rows;
          let dropList = [];
          for (let index = 0; index < ll.length; index++) {
            const element = ll[index];

              let xx = {};
              xx.value = element.id;
              xx.name = element.supplierName;
              // xx.children = element.children || [];
              dropList.push(xx);

          }
          for (let index = 0; index < this.items.length; index++) {
            const element = this.items[index];
            if (element && element.name == "supplierId") {
              // this.items[index]['dropList'] = dropList
              this.items[index]["dropList"] = (
                  this.items[index]["dropList"] || []
              ).concat(dropList);
            }
          }
        }
      },
        async getFacilityType(facilityTypeId) {
            let d = {
                customerId: Number(customerId) === 0 ? window.localStorage.getItem("customerIdClick") : Number(customerId)
            }
            let res = await $utils.api.load('/admin/system/facilityType/selectListRate', d, "get")
            // console.log(res);
            if (res.code == 200) {
                // this.buildingList = res.rows
                let ll = res.rows;
                let dropList = [];
                for (let index = 0; index < ll.length; index++) {
                    const element = ll[index];

                        let xx = {};
                        xx.value = element.id;
                        xx.name = element.facilityName;
                        // xx.children = element.children || [];
                        dropList.push(xx);

                }
                for (let index = 0; index < this.items.length; index++) {
                    const element = this.items[index];
                    if (element && element.name == "facilityTypeId") {
                        // this.items[index]['dropList'] = dropList
                        this.items[index]["dropList"] = (
                            this.items[index]["dropList"] || []
                        ).concat(dropList);
                    }
                }
            }
        },
    }
};
</script>
